module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-5-0d2da358ec3d616ed170bfec2ae522f1.svg";